// src/redux/slices/authSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { ApiBaseUrl, updatePasswordClient } from "../../Utils/Constants";
import { toast } from "react-toastify";

export const hitUpdatePasswordClientApi = createAsyncThunk("hitUpdatePasswordClientApi", async (payload) => {
  try {
    const config = {
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json",
        Authorization: `${localStorage.getItem("clientToken")}`,
      },
    };
    const url = ApiBaseUrl + updatePasswordClient;
    const response = await axios.put(url, payload, config);
    return response.data;
  } catch (error) {
    toast.error(error.response.data.message);
    throw error.response.data;
  }
});

const UpdatePasswordClientSlice = createSlice({
  name: "updatePasswordClientReducer",
  initialState: {
    isLoading: false,
    data: null,
  },
  reducers: {
    clearhitUpdatePasswordClientData: (state) => {
      state.data = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(hitUpdatePasswordClientApi.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(hitUpdatePasswordClientApi.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(hitUpdatePasswordClientApi.rejected, (state) => {
        state.isError = false;
      });
  },
});

export const { clearhitUpdatePasswordClientData } = UpdatePasswordClientSlice.actions;
export default UpdatePasswordClientSlice.reducer;
